export default "__VITE_ASSET__Dfozi0St__"